import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { useDispatch, useSelector } from "react-redux";
import { SET_CURRENTLY_DRAGGING } from "../../Constants/reducerEvents";

export default function ScheduledTask({ task, setComplete }) {
  const dispatch = useDispatch();

  const event = useSelector((state) =>
    state.tasks.find((c) => c.id === task.taskId)
  );
  const courseColor = useSelector((state) =>
    state.courses.find((c) => c.id === event?.courseId)
  )?.color;
  const getBorderColor = () => {
    if (!event) {
      return "beige";
    }
    switch (event.type) {
      case "EVENT":
        return "#457b3b";
      case "ASSIGNMENT":
        return "#3873cb";
      case "EXAM":
        return "red";
      case "QUIZ":
        return "#9031aa";
    }
  };

  return (
    <div
      style={{
        backgroundColor: courseColor ? courseColor : event ? "#eee" : "beige",
        borderRadius: "5px",
        margin: "2px",
        borderRight: "26px solid",
        borderRightColor: getBorderColor(),
        textAlign: "center",

        color: "black",
        display: "flex",
        position: "relative",
      }}
    >
      <div
        style={{
          paddingTop: "5px",
          paddingBottom: "5px",
          paddingLeft: "4px",
          flexGrow: 1,
          whiteSpace: "normal",
        }}
      >
        {task.name}
      </div>
      {setComplete && (
        <div
          style={{
            position: "absolute",
            right: -25,
            top: 3,
            width: "24px",
            minHeight: "20px",
            height: "100%",
            cursor: "pointer",
          }}
          onClick={() => {
            dispatch({ type: SET_CURRENTLY_DRAGGING, payload: false });
            setComplete(task);
          }}
        >
          <CheckCircleOutlineOutlinedIcon style={{ fill: "black" }} />
        </div>
      )}
    </div>
  );
}
